import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconX = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z" }, void 0) }, void 0));
const Memo = memo(SvgIconX);
export default Memo;
//# sourceMappingURL=IconX.js.map